import { Link } from "react-router-dom";
import PublicFooter from "../components/PublicFooter";

export default function TermsAndConditions({ user, onLogout }) {
  return (
    <main className="public-shell">
      <aside className="public-sidebar">
        <div className="sidebar-brand">
          <p className="sidebar-brand-title">DR Rentals</p>
          <p className="sidebar-brand-subtitle">Informatie</p>
        </div>

        <Link className="sidebar-button" to="/">Homepagina</Link>
        <Link className="sidebar-button" to="/contact">Contact</Link>
        {user && <Link className="sidebar-button" to="/dashboard">Dashboard</Link>}

        <div className="public-sidebar-bottom">
          {user ? (
            <button className="sidebar-button danger" onClick={onLogout}>
              Afmelden
            </button>
          ) : (
            <Link className="sidebar-button" to="/login">
              Medewerker login
            </Link>
          )}
        </div>
      </aside>

      <section className="public-page">
        <article className="panel panel-pad public-intro legal-page">
          <h1 className="page-title">Algemene Voorwaarden</h1>

          <p className="page-subtitle">
            Deze algemene voorwaarden zijn van toepassing op alle reservaties,
            huurovereenkomsten en diensten aangeboden door DR Rentals,
            ondernemingsnummer BE 0720.658.431.
          </p>
          <p className="page-subtitle">
            DR Rentals is een handelsnaam van Cedric Coudijzer, geregistreerd
            onder ondernemingsnummer BE 0720.658.431.
          </p>

          <section className="legal-section">
            <h2>1. Identiteit van de onderneming</h2>
            <p>
              DR Rentals<br />
              Handelsnaam van Cedric Coudijzer<br />
              Ondernemingsnummer: BE 0720.658.431<br />
              E-mail: info@dr-rentals.be<br />
              Telefoon: 0479 65 88 28
            </p>
          </section>

          <section className="legal-section">
            <h2>2. Reservaties</h2>
            <p>
              Een reservatie is pas definitief nadat de huurder alle gevraagde
              gegevens heeft verstrekt, de vereiste documenten heeft bezorgd en
              DR Rentals de reservatie heeft bevestigd.
            </p>
            <p>
              DR Rentals behoudt zich het recht voor om een reservatie te
              weigeren bij onvolledige gegevens, ontbrekende documenten,
              vermoeden van misbruik of andere gegronde redenen.
            </p>
          </section>

          <section className="legal-section">
            <h2>3. Vereiste documenten</h2>
            <p>
              De huurder dient vóór aanvang van de huurperiode de gevraagde
              documenten te bezorgen. Dit kan onder meer gaan om een geldige
              identiteitskaart, een geldig rijbewijs en gegevens of documenten
              van het trekkend voertuig.
            </p>
            <p>
              Indien de gevraagde documenten niet tijdig of onvolledig worden
              bezorgd, kan DR Rentals de verhuur weigeren zonder schadevergoeding.
            </p>
          </section>

          <section className="legal-section">
            <h2>4. Huurprijs en betaling</h2>
            <p>
              De huurprijs wordt vooraf overeengekomen op basis van de gekozen
              aanhangwagen, de huurperiode en eventuele extra opties.
            </p>
            <p>
              De betaling gebeurt volgens de instructies van DR Rentals. Bij
              laattijdige, onvolledige of ontbrekende betaling kan DR Rentals de
              reservatie weigeren of annuleren.
            </p>
          </section>

          <section className="legal-section">
            <h2>5. Waarborg</h2>
            <p>
              DR Rentals kan een waarborg vragen vóór de afhaling van de
              aanhangwagen. Deze waarborg dient als zekerheid voor schade,
              ontbrekende onderdelen, laattijdige inlevering, reinigingskosten,
              verkeersboetes of andere kosten die voortvloeien uit de huur.
            </p>
            <p>
              Na controle van de aanhangwagen wordt de waarborg geheel of
              gedeeltelijk vrijgegeven. Eventuele kosten mogen van de waarborg
              worden afgehouden.
            </p>
          </section>

          <section className="legal-section">
            <h2>6. Gebruik van de aanhangwagen</h2>
            <p>
              De huurder verbindt zich ertoe de aanhangwagen als een voorzichtig
              en redelijk persoon te gebruiken. De huurder respecteert steeds de
              technische beperkingen, het maximaal toegelaten gewicht, de
              verkeersregels en de instructies van DR Rentals.
            </p>
            <p>
              Overladen, verkeerd koppelen, onveilig gebruik, doorverhuur of
              gebruik voor illegale activiteiten is verboden.
            </p>
          </section>

          <section className="legal-section">
            <h2>7. Staat van de aanhangwagen</h2>
            <p>
              Bij afhaling wordt de aanhangwagen geacht in goede staat te zijn
              afgeleverd. De huurder dient vóór vertrek de staat van de
              aanhangwagen te controleren, waaronder verlichting, koppeling,
              banden, zichtbare schade en ladingzekering.
            </p>
            <p>
              Eventuele zichtbare gebreken moeten vóór vertrek aan DR Rentals
              worden gemeld. Schade die niet vooraf werd gemeld, wordt geacht
              tijdens de huurperiode te zijn ontstaan.
            </p>
          </section>

          <section className="legal-section">
            <h2>8. Verantwoordelijkheid van de huurder</h2>
            <p>
              De huurder is verantwoordelijk voor de aanhangwagen vanaf het
              moment van afhaling tot de effectieve teruggave aan DR Rentals.
            </p>
            <p>
              De huurder blijft verantwoordelijk voor correcte koppeling,
              correcte belading, beveiliging van de lading en naleving van alle
              toepasselijke wetgeving.
            </p>
          </section>

          <section className="legal-section">
            <h2>9. Schade, verlies of defecten</h2>
            <p>
              Schade, verlies, diefstal, defecten of ongevallen moeten
              onmiddellijk aan DR Rentals worden gemeld.
            </p>
            <p>
              Nieuwe schade vastgesteld tijdens of na de huurperiode kan worden
              aangerekend aan de huurder, tenzij de huurder kan aantonen dat de
              schade niet door hem of haar werd veroorzaakt.
            </p>
            <p>
              De huurder mag geen herstellingen laten uitvoeren zonder
              voorafgaande toestemming van DR Rentals.
            </p>
          </section>

          <section className="legal-section">
            <h2>10. Verkeersovertredingen en boetes</h2>
            <p>
              Alle verkeersboetes, parkeerboetes, tolheffingen, takelkosten,
              retributies of andere sancties die ontstaan tijdens de
              huurperiode zijn volledig ten laste van de huurder.
            </p>
            <p>
              Indien DR Rentals deze kosten ontvangt of moet opvolgen, kunnen
              administratieve kosten worden aangerekend.
            </p>
          </section>

          <section className="legal-section">
            <h2>11. Laattijdige inlevering</h2>
            <p>
              De aanhangwagen moet worden teruggebracht op het afgesproken
              tijdstip. Bij laattijdige inlevering kunnen bijkomende huurkosten,
              schadevergoedingen of kosten door misgelopen reservaties worden
              aangerekend.
            </p>
          </section>

          <section className="legal-section">
            <h2>12. Reiniging</h2>
            <p>
              De aanhangwagen moet proper en in dezelfde staat worden
              teruggebracht als bij afhaling. Indien extra reiniging nodig is,
              kunnen reinigingskosten worden aangerekend aan de huurder.
            </p>
          </section>

          <section className="legal-section">
            <h2>13. Annulering</h2>
            <p>
              Annulaties moeten zo snel mogelijk aan DR Rentals worden gemeld.
              DR Rentals kan kosten aanrekenen wanneer een annulatie laattijdig
              gebeurt of wanneer de gereserveerde aanhangwagen daardoor niet
              meer opnieuw verhuurd kan worden.
            </p>
            <p>
              DR Rentals kan een reservatie annuleren in geval van technische
              defecten, overmacht, veiligheidsredenen of foutieve of onvolledige
              informatie van de huurder.
            </p>
          </section>

          <section className="legal-section">
            <h2>14. Overmacht</h2>
            <p>
              DR Rentals is niet aansprakelijk voor vertragingen of
              niet-uitvoering als gevolg van omstandigheden buiten haar redelijke
              controle, zoals technische defecten, ongevallen, extreme
              weersomstandigheden, overheidsmaatregelen, stakingen of andere
              overmachtssituaties.
            </p>
          </section>

          <section className="legal-section">
            <h2>15. Aansprakelijkheid</h2>
            <p>
              DR Rentals is niet aansprakelijk voor schade aan vervoerde goederen,
              indirecte schade, gevolgschade, inkomstenverlies of schade die
              ontstaat door verkeerd gebruik van de aanhangwagen.
            </p>
            <p>
              De aansprakelijkheid van DR Rentals is in elk geval beperkt tot het
              bedrag van de betaalde huurprijs, behoudens andersluidende
              dwingende wettelijke bepalingen.
            </p>
          </section>

          <section className="legal-section">
            <h2>16. Privacy</h2>
            <p>
              Persoonsgegevens worden verwerkt overeenkomstig het privacybeleid
              van DR Rentals. Het privacybeleid is raadpleegbaar via de website.
            </p>
          </section>

          <section className="legal-section">
            <h2>17. Toepasselijk recht</h2>
            <p>
              Op deze algemene voorwaarden en alle overeenkomsten met DR Rentals
              is uitsluitend Belgisch recht van toepassing.
            </p>
            <p>
              Geschillen worden bij voorkeur minnelijk opgelost. Indien geen
              minnelijke oplossing mogelijk is, zijn de bevoegde Belgische
              rechtbanken van toepassing.
            </p>
          </section>

          <section className="legal-section">
            <h2>18. Contact</h2>
            <p>
              Voor vragen over deze algemene voorwaarden kan de huurder contact
              opnemen met DR Rentals via info@dr-rentals.be of 0479 65 88 28.
            </p>
          </section>
        </article>

        <PublicFooter />
      </section>
    </main>
  );
}
